import {Badge, type BadgeProps} from '@/components/ui/badge'
import {useAppConfig, labelOf} from '@/hooks/use-app-config'

interface RiskLevelBadgeProps {
    riskLevel: string | null | undefined
    className?: string
}

export function RiskLevelBadge({riskLevel, className}: RiskLevelBadgeProps) {
    const {riskLevelTypes} = useAppConfig()

    if (!riskLevel) return <span>{'\u2014'}</span>

    const typeValue = riskLevelTypes.find(t => t.code === riskLevel)
    const variant = (typeValue?.settings?.badgeVariant as BadgeProps['variant']) ?? 'outline'

    return (
        <Badge variant={variant} className={className} data-testid={`risk-badge-${riskLevel}`}>
            {labelOf(riskLevelTypes, riskLevel)}
        </Badge>
    )
}
